/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateWebsiteApiKeyResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type CreateWebsiteApiKeyResponse, type ErrorResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organization/website-api-access
 */
export interface WebsiteApiAccessRequestBuilder extends BaseRequestBuilder<WebsiteApiAccessRequestBuilder> {
    /**
     * Creates API access credentials for the organization's storefront. The credentials are always issued with the storefront scope — the scope is not selectable. Only organizations whose subscription includes the storefront may be issued one, and an organization may hold at most two at a time. The key value is returned once and cannot be retrieved again.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateWebsiteApiKeyResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 401 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateWebsiteApiKeyResponse | undefined>;
    /**
     * Creates API access credentials for the organization's storefront. The credentials are always issued with the storefront scope — the scope is not selectable. Only organizations whose subscription includes the storefront may be issued one, and an organization may hold at most two at a time. The key value is returned once and cannot be retrieved again.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WebsiteApiAccessRequestBuilderUriTemplate = "{+baseurl}/api/organization/website-api-access";
/**
 * Metadata for all the requests in the request builder.
 */
export const WebsiteApiAccessRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: WebsiteApiAccessRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateWebsiteApiKeyResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
